import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import FallbackLoading from "../../common/loader/FallbackLoading";
import { API } from "../../redux/api/utils";
import { setAccessToken, setUserData } from "../../redux/actions/auth_action";

function MobileAuth() {
  const [searchParams] = useSearchParams();
  const [message, setMessage] = useState("Signing you in...");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const token = searchParams.get("token");
    const requestedRedirect = searchParams.get("redirect") || "/home";

    const authenticate = async () => {
      if (!token) {
        setMessage("Invalid mobile access link.");
        return;
      }

      try {
        const { data } = await API.post("/auth/mobile-web/session", { token });
        const profile = { user: data.user, token: data.token };
        const redirectPath = data.redirectPath || requestedRedirect;

        localStorage.setItem("profile", JSON.stringify(profile));
        dispatch(setAccessToken(data.token));
        dispatch(setUserData(data.user));
        navigate(redirectPath, { replace: true });
      } catch (error) {
        setMessage(
          error?.response?.data?.message ||
            "Unable to sign you in. Please reopen this service from the mobile app.",
        );
      }
    };

    authenticate();
  }, [dispatch, navigate, searchParams]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4 bg-[#f5f5f5] px-4 text-center">
      <FallbackLoading />
      <p className="text-sm text-gray-700">{message}</p>
    </div>
  );
}

export default MobileAuth;
